import { Component, Input } from "@angular/core";

@Component({
    selector: 'player-morale-indicator',
    templateUrl: './player-morale-indicator.component.html',
    styleUrls: ['./player-morale-indicator.component.scss'],
})
export class PlayerMoraleIndicatorComponent {
    @Input() morale: number;
}